import React from 'react';
import View from 'components/tmisc/portal/requested/Requested.view';

const PortalRequested = ({ flow }) => {
  return (
    <View
      flow={flow}
    />
  );
}

export default PortalRequested;